var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.979,
    height: 16.979,
    viewBox: "0 0 16.979 16.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17640",
    "data-name": "Group 17640",
    transform: "translate(-1572.51 -386.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-whatsapp",
    "data-name": "Icon awesome-whatsapp",
    d: "M14.436,4.717A8.417,8.417,0,0,0,1.194,14.871L0,19.229l4.461-1.171a8.388,8.388,0,0,0,4.021,1.023h0a8.495,8.495,0,0,0,8.493-8.414,8.447,8.447,0,0,0-2.543-5.95ZM8.486,17.664a6.981,6.981,0,0,1-3.563-.974l-.254-.152-2.645.694.7-2.581-.167-.265a7.007,7.007,0,1,1,13-3.718A7.071,7.071,0,0,1,8.486,17.664Zm3.835-5.238c-.208-.106-1.243-.614-1.436-.682s-.334-.106-.474.106-.542.682-.667.826-.246.159-.455.053a5.723,5.723,0,0,1-2.861-2.5c-.216-.371.216-.345.618-1.148a.39.39,0,0,0-.019-.368c-.053-.106-.474-1.141-.648-1.561S6.034,6.8,5.9,6.79s-.262-.008-.4-.008a.779.779,0,0,0-.561.262A2.362,2.362,0,0,0,4.207,8.8a4.119,4.119,0,0,0,.857,2.175,9.4,9.4,0,0,0,3.593,3.176,4.114,4.114,0,0,0,2.524.527,2.153,2.153,0,0,0,1.417-1,1.758,1.758,0,0,0,.121-1C12.67,12.582,12.53,12.529,12.321,12.426Z",
    transform: "translate(1572.51 384.26)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7bdc1a8c824c168df16cb81d721fabb4.svg";
export { ForwardRef as ReactComponent };